import Binalar from 'assets/icons/Binalar.png'
import { INotificationChartData } from 'types/DashboardType'
import useGetTypeChartData from './use-get-notification-chart'
import DoughnutChartPage from '../../chart-molecules/DoughnutPage/DoughnutChartPage'
import StackedChart from '../../chart-molecules/StackedChart/StackedChart'
import { DropdownWrapper, StyledDropdown } from '../on-campus-container/styled'

interface IChartContainerProps {
  userInfo: any
  firmList: any
  startDate: Date
  endDate: Date
  selectedFirms: any
  chartData: INotificationChartData | undefined
}

const ChartContainerPage = (props: IChartContainerProps) => {
  const { chartType, chartTypeOptions, colors, detailTitle, handleChartTypeChange, items, labels, t } =
    useGetTypeChartData(props)

  const translatedLabels = labels.map((label) => t(label))

  return (
    <div className="row">
      {(props.firmList.length > 1 || props.userInfo === 'SuperAdmin') && (
        <div className="col-3 d-flex justify-content-between flex-column">
          <DropdownWrapper>
            <StyledDropdown
              appendTo="self"
              value={chartType}
              onChange={handleChartTypeChange}
              options={chartTypeOptions}
              optionLabel="value"
              optionValue="key"
            />
          </DropdownWrapper>

          <DoughnutChartPage
            colors={colors}
            labels={translatedLabels}
            icon={<img src={Binalar} width={'40px'} alt="firms1" />}
            items={chartType !== 'all' ? undefined : items}
            detailTitle={t(detailTitle)}
            totalNotification={items?.doughnutItems.total}
          />

          <div>
            <p style={{ fontSize: '14px' }}>{t('dashboard.dist-footer-text')}</p>
          </div>
        </div>
      )}

      <div className={props.firmList.length > 1 || props.userInfo === 'SuperAdmin' ? 'col-9' : 'col-12 '}>
        <StackedChart
          chartId="notificationChart"
          tabIndex={0}
          colors={colors}
          checkedValue={''}
          setCheckedValue={''}
          labels={translatedLabels}
          tooltipLabel={t('dashboard.notification-tooltip')}
          response={items}
          userInfo={props.userInfo}
        />
      </div>
    </div>
  )
}

export default ChartContainerPage
